import axios from 'axios';

const api = axios.create({
  baseURL: 'https://proffy-tito.herokuapp.com',
});

export default api;
